/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-20 23:30 VN — STKPVFIX2 (WEB-20261020-suzitee-ab-cartpv)
   Đã làm: hit GA4 A/B giỏ dùng sid/sct phiên GA4 THẬT từ cookie _ga_Z2ZXTNKB4V (như gaSess() của sz-ab-stkpv.js) thay cho sid tự đặt
   trong sessionStorage (sz_ab_sid) — sid tự đặt làm GA4 đếm thêm 1 phiên giả không page_view cho mỗi khách mở giỏ. Chưa có cookie → bỏ hit GA4
   (beacon /szab/e, dataLayer, Shopify.analytics vẫn bắn như cũ). Không đổi giao diện/chia bản/nhãn giỏ. */
/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-20 14:50 VN — WEB-20261020-suzitee-ab-cartpv-9010 (lane ABPVX)
   Đã làm: đợt A/B 2 (B 90% / A 10%, khoá v2): (1) mọi sự kiện mang tv=<đợt> (lấy từ snippet, đợt 2) + GA4 ab_test=cartpv2;
   (2) cart attribute thêm _sz_ab_v=<đợt>, khoá đánh dấu đã gắn theo đợt → giỏ còn nhãn đợt 50/50 được ghi đè nhãn mới khi mở giỏ;
   (3) phát hiện muộn thanh admin/preview Shopify (iframe chèn sau <head>) → coi là nội bộ: q=1 + đặt cookie sz_internal=1;
   (4) GIẢM INP cú bấm (đo lane ABPVX, Chrome 390 CPU 4x: hàm click cũ chạy ~34ms/cú bấm, dataLayer.push riêng ~14ms vì GTM xử lý đồng bộ):
   beacon /szab/e (nhẹ, phải gửi trước khi chuyển sang checkout) giữ ngay lúc bấm; dataLayer + Shopify.analytics.publish + GA4 dời ra
   SAU khi trình duyệt vẽ khung của cú bấm (rAF → setTimeout, chậm nhất 250ms). Kiểm thanh admin bằng getElementById (querySelector danh sách id quét cả DOM ~3,8ms). */
/* AI Agent làm theo chỉ thị của anh Hoá — 2026-10-20 03:40 VN — WEB-20261020-suzitee-ab-cartpv
   Đã làm: ĐO A/B nút Preview trong giỏ (drawer + /cart). Bản (A|B) đã chia sẵn ở snippets/sz-ab-cartpv.liquid (window.__szAbCpv).
   File này CHỈ QUAN SÁT, không đổi giao diện/luồng: (1) ghi bản vào cart attribute _sz_ab_cartpv (+ _sz_ab_cid) bằng sendBeacon
   /cart/update.js (chỉ attributes → KHÔNG đụng dòng hàng/properties Customily; đánh dấu __szmcSelf để drawer không vẽ lại),
   kiểm lại bằng GET /cart.js, tối đa 3 lần; (2) bắn sự kiện cart_view, preview_click, see_inside_click, giftbox_remove,
   checkout_click kèm ab_variant → beacon updates.cozyplus.co/szab/e (nguồn của báo cáo 9:00) + GA4 G-Z2ZXTNKB4V (gói /g/collect,
   không nạp gtag.js) + dataLayer + Shopify.analytics.publish('sz_ab_cartpv'). Nghe click ở pha CAPTURE trên window (chạy trước
   handler document của sz-cart-pv.js / sz-addon-cart.js nên không bị stopPropagation nuốt); không MutationObserver; lỗi gì cũng nuốt.
   Bot → không bắn; QC (?sz_qc=1 / ?sz_ab= / headless / webdriver) → bắn kèm q=1, theme nháp → pt=1, báo cáo loại cả hai. Tắt: xem snippets/sz-ab-cartpv.liquid. */
(function () {
  try {
    var A = window.__szAbCpv;
    if (!A || A.bot || window.__szAbCpvJs) return;
    window.__szAbCpvJs = 1;
    var V = A.v === 'B' ? 'B' : 'A', C = A.c || '', Q = A.q ? 1 : 0, TV = +A.tv || 1;
    /* phiên xem theme nháp (?preview_theme_id) → pt=1, báo cáo loại ra, không gửi GA4 */
    var PT = 0; try { PT = (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') ? 1 : 0; } catch (e) {}
    var EP = 'https://updates.cozyplus.co/szab/e', GA = 'G-Z2ZXTNKB4V', AT = TV > 1 ? 'cartpv' + TV : 'cartpv';
    var PL = Math.random().toString(36).slice(2, 9);
    var CART_PAGE = !!document.getElementById('cart_form') && !(document.getElementById('cart_form').closest('.szmc-dw'));
    var log = window.__szAbCpvLog = [];
    /* thanh admin/preview của Shopify chỉ hiện với nhân viên đăng nhập — chèn sau <head> nên snippet không thấy kịp → kiểm lại ở đây */
    function staff() {
      try { if (!Q && (document.getElementById('admin-bar-iframe') || document.getElementById('preview-bar-iframe') || document.getElementById('PBarNextFrameWrapper'))) { Q = 1; document.cookie = 'sz_internal=1;path=/;max-age=31536000;SameSite=Lax'; } } catch (e) {}
    }
    /* chạy f sau khi trình duyệt vẽ xong khung hiện tại (không cộng vào INP của cú bấm); rAF bị hoãn khi tab ẩn → chốt chặn 250ms; chạy đúng 1 lần */
    function later(f) {
      var done = 0; function g() { if (done) return; done = 1; try { f(); } catch (e) {} }
      try { requestAnimationFrame(function () { setTimeout(g, 0); }); } catch (e) {}
      setTimeout(g, 250);
    }

    function dev() { try { return window.matchMedia('(max-width:798px)').matches ? 'm' : 'd'; } catch (e) { return 'd'; } }
    function consent() {
      try { var p = window.Shopify && window.Shopify.customerPrivacy; if (p && typeof p.analyticsProcessingAllowed === 'function') return !!p.analyticsProcessingAllowed(); } catch (e) {}
      return true;
    }
    /* giỏ đang nhìn thấy: drawer đang mở → .szmc-dw; không thì trang /cart */
    function scope() {
      var d = document.documentElement.classList.contains('szmc-open') && document.querySelector('.szmc-dw');
      return d || (CART_PAGE ? document.getElementById('cart_form') : null) || document.querySelector('.szmc-dw');
    }
    function counts(root) {
      root = root || scope();
      if (!root) return { n: 0, pv: 0, ad: 0 };
      return {
        n: root.querySelectorAll('.cart__item').length,
        pv: root.querySelectorAll('.cart__item a.customily-preview-cart').length,
        ad: root.querySelectorAll('.cart__item a.preview-image[data-sz-addon]').length
      };
    }
    function enc(o) { var a = []; for (var k in o) if (o[k] !== undefined && o[k] !== '') a.push(k + '=' + encodeURIComponent(o[k])); return a.join('&'); }
    function beacon(u) {
      try { if (navigator.sendBeacon && navigator.sendBeacon(u)) return; } catch (e) {}
      try { var i = new Image(); i.src = u; } catch (e) {}
    }
    function gaCid() { var m = document.cookie.match(/(?:^|; )_ga=GA\d\.\d\.(\d+\.\d+)/); return m ? m[1] : C; }
    /* phiên GA4 THẬT của gtag (cookie _ga_Z2ZXTNKB4V: GS1.1.<sid>.<sct>… hoặc GS2.1.s<sid>$o<sct>…); không có cookie → null, không gửi GA4 */
    function gaSess() {
      try {
        var m = document.cookie.match(/(?:^|; )_ga_Z2ZXTNKB4V=([^;]+)/); if (!m) return null; var v = decodeURIComponent(m[1]), x;
        if ((x = /^GS1\.\d\.(\d+)\.(\d+)/.exec(v))) return { sid: x[1], sct: x[2] };
        if ((x = /^GS2\.\d\.s(\d+)(?:\$o(\d+))?/.exec(v))) return { sid: x[1], sct: x[2] || '1' };
      } catch (e) {}
      return null;
    }
    function send(e, x) {
      staff();
      var c = counts(), o = { e: e, v: V, c: C, d: dev(), p: PL, q: Q, pt: PT, tv: TV, t: CART_PAGE ? 'cart' : 'other', n: c.n, pv: c.pv, ad: c.ad };
      for (var k in (x || {})) o[k] = x[k];
      log.push(o);
      var ok = consent();
      if (ok) beacon(EP + '?' + enc(o));
      later(function () {
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'sz_ab_cartpv', ab_test: AT, ab_variant: V, ab_event: e, ab_src: o.s || '' }); } catch (er) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('sz_ab_cartpv', { ab_test: AT, ab_variant: V, ab_event: e, src: o.s || '', device: o.d, qc: Q }); } catch (er) {}
      var gs = (ok && !Q && !PT) ? gaSess() : null;
      if (gs) {
        beacon('https://www.google-analytics.com/g/collect?' + enc({
          v: 2, tid: GA, cid: gaCid(), sid: gs.sid, sct: gs.sct, seg: 1, _et: 1, en: e,
          'ep.ab_variant': V, 'ep.ab_test': AT, 'ep.ab_src': o.s || '', 'ep.ab_device': o.d,
          dl: location.origin + location.pathname, dt: (document.title || '').slice(0, 100)
        }));
      }
      });
    }

    /* ---- (1) gắn bản lên giỏ ---- */
    var TAGK = 'sz_ab_cpv_tag' + (TV > 1 ? TV : ''), tagBusy = 0, tagTry = 0;
    function cartTok() { var m = document.cookie.match(/(?:^|; )cart=([^;]+)/); return m ? decodeURIComponent(m[1]).split('?')[0] : ''; }
    function tagged() { try { var t = cartTok(); return !!t && sessionStorage.getItem(TAGK) === t + '|' + V; } catch (e) { return false; } }
    function tag() {
      if (tagBusy || tagged() || tagTry >= 3) return;
      tagBusy = 1; tagTry++; staff();
      var body = enc({ 'attributes[_sz_ab_cartpv]': V, 'attributes[_sz_ab_cid]': C, 'attributes[_sz_ab_qc]': Q ? '1' : '', 'attributes[_sz_ab_v]': TV > 1 ? String(TV) : '' });
      window.__szmcSelf = Date.now();
      var sent = false;
      try { sent = navigator.sendBeacon && navigator.sendBeacon('/cart/update.js', new Blob([body], { type: 'application/x-www-form-urlencoded' })); } catch (e) {}
      if (!sent) { tagBusy = 0; return; }
      setTimeout(function () {
        try {
          fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (j) {
              tagBusy = 0;
              var at = (j && j.attributes) || {};
              if (at._sz_ab_cartpv === V && (TV < 2 || at._sz_ab_v === String(TV))) { try { sessionStorage.setItem(TAGK, (cartTok() || j.token || '') + '|' + V); } catch (e) {} }
              else if (j && j.item_count > 0) setTimeout(tag, 4000);
            })['catch'](function () { tagBusy = 0; });
        } catch (e) { tagBusy = 0; }
      }, 2500);
    }

    /* ---- (2) cart_view: 1 lần / lượt tải trang, chỉ khi giỏ có hàng (chờ drawer vẽ dòng, tối đa ~6s) ---- */
    var viewed = 0;
    function cartView(src, tries) {
      if (viewed) return;
      var c = counts(), k = tries || 0;
      /* drawer mở kiểu instant có thể chưa có dòng mới ("Adding…") → chờ thêm để đếm đúng dòng cá nhân hoá/add-on */
      if ((!c.n && k < 5) || (c.n && !c.pv && !c.ad && k < 3)) { setTimeout(function () { cartView(src, k + 1); }, 1200); return; }
      if (!c.n) return;
      viewed = 1;
      send('cart_view', { s: src });
      tag();
    }
    document.addEventListener('szmc:open', function () { try { cartView('drawer', 0); } catch (e) {} });
    function pageInit() { try { if (CART_PAGE) cartView('page', 0); } catch (e) {} }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pageInit); else pageInit();

    /* ---- (3) click: pha CAPTURE trên window ---- */
    var lastCo = 0;
    function co(src) {
      var t = Date.now();
      if (t - lastCo < 2000) return;
      lastCo = t;
      send('checkout_click', { s: src });
      if (!tagged()) tag();
    }
    window.addEventListener('click', function (ev) {
      try {
        var t = ev.target; if (!t || !t.closest) return;
        var el;
        if (t.closest('.sz-cpv__go')) { co('pvpop'); return; }
        if ((el = t.closest('.sz-addon-modal--cart .sz-addon-go'))) { co('adpop'); return; }
        if ((el = t.closest('[name="checkout"], #szMdockCheckout, .eb-checkout-btn'))) { co(el.id === 'szMdockCheckout' ? 'dock' : 'btn'); return; }
        var line = t.closest('.cart__item'); if (!line) return;
        if (t.closest('a.customily-preview-cart')) { send('preview_click', { s: 'btn' }); return; }
        if (t.closest('a.sz-addon-see')) { send('see_inside_click', { s: 'link' }); return; }
        if ((el = t.closest('a.preview-image'))) { send(el.hasAttribute('data-sz-addon') ? 'see_inside_click' : 'preview_click', { s: 'img' }); return; }
        if ((el = t.closest('a.cart-remove-btn')) && line.querySelector('a.preview-image[data-sz-addon]')) {
          send('giftbox_remove', { s: el.__szGbxGo ? 'go' : 'ask' });
        }
      } catch (e) {}
    }, true);
  } catch (e) {}
})();
